module.exports = __webpack_public_path__ + "static/media/8. Inundando el alma, Mixta en tela, 190 x 240 cm, 2014 copy.47fa0ecc.png";